module.exports = __webpack_public_path__ + "img/logo-call-1.c7b10308.svg";